export default __webpack_public_path__ + "static/media/coralie.6eaaec95.png";